import useQueryBuilding from "ApiLayer/Building/queryBuildingModel";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { useParams, useSearchParams } from "react-router-dom";
import BuildingQuickDisplay from "./BuildingQuickDisplay";
import styles from "./Sandbox.module.scss";

function BuildingSandboxPage() {
    const { buildingModelUid } = useParams();
    const [searchParams] = useSearchParams();
    const { data: buildingModel, isLoading } = useQueryBuilding(buildingModelUid || "");

    if (isLoading) return <LoadingSpinner />;
    if (!buildingModel) return <div>No building data found</div>;

    return (
        <div>
            <div className={styles["sandbox-item"]}>
                <h3>URL Parameters</h3>
                <pre>
                    {JSON.stringify(
                        {
                            buildingModelUid,
                            tab: searchParams.get("tab"),
                            url: window.location.href,
                        },
                        null,
                        2
                    )}
                </pre>
            </div>

            <div className={styles["sandbox-item"]}>
                <h3>Building Model</h3>
                <BuildingQuickDisplay buildingModel={buildingModel} />
            </div>
        </div>
    );
}

export default BuildingSandboxPage;
